const digitsRE = /(\d{3})(?=\d)/g
/**
 * [currency 金额格式化后并四舍五入函数；]
 * @param  {[type]} value    [传进来的值]
 * @param  {[type]} currency [货币符号]
 * @param  {[type]} decimals [小数位数]
 * @return {[type]}          [description]
 */
export function moneyFomart(value, decimals, currency) {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency = currency != null ? currency : '￥'
  decimals = decimals != null ? decimals : 2
  // console.log(Math.abs(value))
  var stringified = toFixed(Math.abs(value), decimals)
  // console.log(Math.abs(stringified))
  var _int = decimals ?
    stringified.slice(0, -1 - decimals) :
    stringified
  var i = _int.length % 3
  var head = i > 0 ?
    (_int.slice(0, i) + (_int.length > 3 ? ',' : '')) :
    ''
  var _float = decimals ?
    stringified.slice(-1 - decimals) :
    ''
  var sign = value < 0 ? '-' : ''
  return currency + sign + head +
    _int.slice(i).replace(digitsRE, '$1,') +
    _float
}
/**
 * 处理小数点中最后一位为5时，被舍掉问题
 * @param {Object} num Number类型金额
 * @param {Object} decimals 保留小数点位数
 */
function toFixed(num, decimals) {
  var str = num + ''
  //判断num中是否存在小数点
  if (str.indexOf(".") !== -1) {
    var len = str.length
    var last = str.substr(len - 1, len)
    if (last == '5') {
      last = '5'
      str = str.substr(0, len - 1) + last
      return Number(str).toFixed(decimals)
    } else {
      return num.toFixed(decimals)
    }
  } else {
    return num.toFixed(decimals)
  }
}

/**
 * 小数计算
 * @param data1
 * @param data2
 * @returns {number}
 */
export function addNum(data1, data2) {
  let ecimalPlaces1, ecimalPlaces2; //数据1和2的小数点的位数
  let max, diffValue;
  ecimalPlaces1 = (data1.toString().split('.')[1] || '').length;
  ecimalPlaces2 = (data2.toString().split('.')[1] || '').length;
  diffValue = Math.abs(ecimalPlaces1 - ecimalPlaces2);
  max = Math.pow(10, Math.max(ecimalPlaces1, ecimalPlaces2));
  if (diffValue > 0) {
    let multipleOf10 = Math.pow(10, diffValue);
    if (ecimalPlaces1 > ecimalPlaces2) {
      data1 = Number(data1.toString().replace(".", ""));
      data2 = Number(data2.toString().replace(".", "")) * multipleOf10;
    } else {
      data1 = Number(data1.toString().replace(".", "")) * multipleOf10;
      data2 = Number(data2.toString().replace(".", ""));
    }
  } else {
    data1 = Number(data1.toString().replace(".", ""));
    data2 = Number(data2.toString().replace(".", ""));
  }
  return (data1 + data2) / max;
}
